import closeAlert from './close-alert.action';

export default closeAlert;
